// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/automations/v1/automations.proto" (package "c1.api.automations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { ConflictMonitorRef } from "../../accessconflict/v1/accessconflict";
import { Form } from "../../form/v1/form";
import { AppUserType } from "../../app/v1/app_user";
import { ConnectorRef } from "../../app/v1/connector";
import { Struct } from "../../../../google/protobuf/struct";
import { UserStatus } from "../../user/v1/user";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Duration } from "../../../../google/protobuf/duration";
import { UserRef } from "../../user/v1/user";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationsRequest
 */
export interface SearchAutomationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTemplateRef refs = 4;
     */
    refs: AutomationTemplateRef[];
    /**
     * @generated from protobuf field: string app_id = 5;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.TriggerType trigger_types = 6;
     */
    triggerTypes: TriggerType[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationsResponse
 */
export interface SearchAutomationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.Automation list = 1;
     */
    list: Automation[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsRequest
 */
export interface SearchAutomationTemplateVersionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string automation_template_id = 3;
     */
    automationTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsResponse
 */
export interface SearchAutomationTemplateVersionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTemplateVersion list = 1;
     */
    list: AutomationTemplateVersion[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationRequest
 */
export interface GetAutomationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationResponse
 */
export interface GetAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1;
     */
    automation?: Automation;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateAutomationRequest
 */
export interface CreateAutomationRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: bool enabled = 3;
     */
    enabled: boolean;
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 4 [deprecated = true];
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep automation_steps = 5;
     */
    automationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger triggers = 6;
     */
    triggers: AutomationTrigger[];
    /**
     * the app id this workflow_template belongs to
     *
     * @generated from protobuf field: string app_id = 7;
     */
    appId: string;
    /**
     * @generated from protobuf field: bool is_draft = 8;
     */
    isDraft: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep draft_automation_steps = 9;
     */
    draftAutomationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger draft_triggers = 10;
     */
    draftTriggers: AutomationTrigger[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateAutomationResponse
 */
export interface CreateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1;
     */
    automation?: Automation;
    /**
     * If we create a new trigger with an HMAC secret we return the HMAC on this field
     *
     * @generated from protobuf field: string webhook_hmac_secret = 2;
     */
    webhookHmacSecret: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ExecuteAutomationRequest
 */
export interface ExecuteAutomationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 2;
     */
    context?: AutomationContext;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ExecuteAutomationResponse
 */
export interface ExecuteAutomationResponse {
    /**
     * @generated from protobuf field: int64 execution_id = 1;
     */
    executionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UpdateAutomationRequest
 */
export interface UpdateAutomationRequest {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1;
     */
    automation?: Automation;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UpdateAutomationResponse
 */
export interface UpdateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.Automation automation = 1;
     */
    automation?: Automation;
    /**
     * If we create a new trigger with an HMAC secret we return the HMAC on this field
     *
     * @generated from protobuf field: string webhook_hmac_secret = 2;
     */
    webhookHmacSecret: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.DeleteAutomationRequest
 */
export interface DeleteAutomationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.DeleteAutomationResponse
 */
export interface DeleteAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationsRequest
 */
export interface ListAutomationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationsResponse
 */
export interface ListAutomationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.Automation list = 1;
     */
    list: Automation[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.Automation
 */
export interface Automation {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: bool enabled = 4;
     */
    enabled: boolean;
    /**
     * @generated from protobuf oneof: disabled_reason
     */
    disabledReason: {
        oneofKind: "circuitBreaker";
        /**
         * @generated from protobuf field: c1.api.automations.v1.DisabledReasonCircuitBreaker circuit_breaker = 101;
         */
        circuitBreaker: DisabledReasonCircuitBreaker;
    } | {
        oneofKind: undefined;
    };
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 5 [deprecated = true];
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep automation_steps = 6;
     */
    automationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger triggers = 7;
     */
    triggers: AutomationTrigger[];
    /**
     * @generated from protobuf field: c1.api.automations.v1.TriggerType primary_trigger_type = 15;
     */
    primaryTriggerType: TriggerType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_executed_at = 8;
     */
    lastExecutedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 9;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep draft_automation_steps = 10;
     */
    draftAutomationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger draft_triggers = 11;
     */
    draftTriggers: AutomationTrigger[];
    /**
     * @generated from protobuf field: bool is_draft = 12;
     */
    isDraft: boolean;
    /**
     * @generated from protobuf field: int64 current_version = 13;
     */
    currentVersion: number;
    /**
     * the app id this workflow_template belongs to
     *
     * @generated from protobuf field: string app_id = 14;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.DisabledReasonCircuitBreaker
 */
export interface DisabledReasonCircuitBreaker {
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationTemplateRef
 */
export interface AutomationTemplateRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationStep
 */
export interface AutomationStep {
    /**
     * @generated from protobuf field: string step_name = 1;
     */
    stepName: string;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "createAccessReview";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CreateAccessReview create_access_review = 101;
         */
        createAccessReview: CreateAccessReview;
    } | {
        oneofKind: "waitForDuration";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WaitForDuration wait_for_duration = 102;
         */
        waitForDuration: WaitForDuration;
    } | {
        oneofKind: "unenrollFromAllAccessProfiles";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UnenrollFromAllAccessProfiles unenroll_from_all_access_profiles = 103;
         */
        unenrollFromAllAccessProfiles: UnenrollFromAllAccessProfiles;
    } | {
        oneofKind: "createRevokeTasks";
        /**
         * @deprecated
         * @generated from protobuf field: c1.api.automations.v1.CreateRevokeTasks create_revoke_tasks = 104 [deprecated = true];
         */
        createRevokeTasks: CreateRevokeTasks;
    } | {
        oneofKind: "createRevokeTasksV2";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CreateRevokeTasksV2 create_revoke_tasks_v2 = 117;
         */
        createRevokeTasksV2: CreateRevokeTasksV2;
    } | {
        oneofKind: "sendEmail";
        /**
         * @generated from protobuf field: c1.api.automations.v1.SendEmail send_email = 105;
         */
        sendEmail: SendEmail;
    } | {
        oneofKind: "removeFromDelegation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RemoveFromDelegation remove_from_delegation = 106;
         */
        removeFromDelegation: RemoveFromDelegation;
    } | {
        oneofKind: "runAutomation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RunAutomation run_automation = 107;
         */
        runAutomation: RunAutomation;
    } | {
        oneofKind: "updateUser";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UpdateUser update_user = 108;
         */
        updateUser: UpdateUser;
    } | {
        oneofKind: "taskAction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.TaskAction task_action = 109;
         */
        taskAction: TaskAction;
    } | {
        oneofKind: "webhook";
        /**
         * @generated from protobuf field: c1.api.automations.v1.Webhook webhook = 110;
         */
        webhook: Webhook;
    } | {
        oneofKind: "connectorAction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ConnectorAction connector_action = 111;
         */
        connectorAction: ConnectorAction;
    } | {
        oneofKind: "connectorCreateAccount";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ConnectorCreateAccount connector_create_account = 112;
         */
        connectorCreateAccount: ConnectorCreateAccount;
    } | {
        oneofKind: "grantEntitlements";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlements grant_entitlements = 113;
         */
        grantEntitlements: GrantEntitlements;
    } | {
        oneofKind: "sendSlackMessage";
        /**
         * @generated from protobuf field: c1.api.automations.v1.SendSlackMessage send_slack_message = 114;
         */
        sendSlackMessage: SendSlackMessage;
    } | {
        oneofKind: "callFunction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CallFunction call_function = 115;
         */
        callFunction: CallFunction;
    } | {
        oneofKind: "accountLifecycleAction";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccountLifecycleAction account_lifecycle_action = 116;
         */
        accountLifecycleAction: AccountLifecycleAction;
    } | {
        oneofKind: "generatePassword";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GeneratePassword generate_password = 120;
         */
        generatePassword: GeneratePassword;
    } | {
        oneofKind: "evaluateExpressions";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EvaluateExpressions evaluate_expressions = 121;
         */
        evaluateExpressions: EvaluateExpressions;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string skip_if_true_cel = 2;
     */
    skipIfTrueCel: string;
    /**
     * @generated from protobuf field: string step_display_name = 3;
     */
    stepDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SendEmail
 */
export interface SendEmail {
    /**
     * @generated from protobuf field: string subject = 1;
     */
    subject: string;
    /**
     * @generated from protobuf field: string body = 2;
     */
    body: string;
    /**
     * @generated from protobuf field: string title = 3;
     */
    title: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 4;
     */
    userRefs: UserRef[];
    /**
     * @generated from protobuf field: string user_ids_cel = 5;
     */
    userIdsCel: string;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 6;
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SendSlackMessage
 */
export interface SendSlackMessage {
    /**
     * @generated from protobuf field: string body = 1;
     */
    body: string;
    /**
     * @generated from protobuf oneof: channel
     */
    channel: {
        oneofKind: "channelName";
        /**
         * @generated from protobuf field: string channel_name = 2;
         */
        channelName: string;
    } | {
        oneofKind: "channelNameCel";
        /**
         * @generated from protobuf field: string channel_name_cel = 3;
         */
        channelNameCel: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.CallFunction
 */
export interface CallFunction {
    /**
     * @generated from protobuf field: string function_id = 1;
     */
    functionId: string;
    /**
     * @generated from protobuf field: map<string, string> args = 2;
     */
    args: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateAccessReview
 */
export interface CreateAccessReview {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: string access_review_template_cel = 2;
     */
    accessReviewTemplateCel: string;
    /**
     * @generated from protobuf field: string user_ids_cel = 3;
     */
    userIdsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 4;
     */
    userRefs: UserRef[];
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 5;
     */
    useSubjectUser: boolean;
    /**
     * Optional campaign name. If not provided, the campaign name will be the access review template name.
     *
     * @generated from protobuf field: string campaign_name = 6;
     */
    campaignName: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.WaitForDuration
 */
export interface WaitForDuration {
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 1;
     */
    duration?: Duration;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UnenrollFromAllAccessProfiles
 */
export interface UnenrollFromAllAccessProfiles {
    /**
     * @generated from protobuf field: string user_ids_cel = 1;
     */
    userIdsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 2;
     */
    userRefs: UserRef[];
    /**
     * Optional list of catalog IDs to unenroll from. If empty, unenroll from all catalogs.
     *
     * @generated from protobuf field: repeated string catalog_ids = 3;
     */
    catalogIds: string[];
    /**
     * CEL expression to dynamically select catalog IDs. If provided, overrides catalog_ids.
     *
     * @generated from protobuf field: string catalog_ids_cel = 5;
     */
    catalogIdsCel: string;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 4;
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateRevokeTasks
 */
export interface CreateRevokeTasks {
    /**
     * @generated from protobuf field: string user_id_cel = 1;
     */
    userIdCel: string;
    /**
     * Required only if user_id_cel is not provided.
     *
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2;
     */
    userRef?: UserRef;
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 3;
     */
    appEntitlementRefsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 4;
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: bool revoke_all = 5;
     */
    revokeAll: boolean;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 6;
     */
    useSubjectUser: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 7;
     */
    excludedAppEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string excluded_app_entitlement_refs_cel = 8;
     */
    excludedAppEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CreateRevokeTasksV2
 */
export interface CreateRevokeTasksV2 {
    /**
     * @generated from protobuf oneof: user
     */
    user: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 1;
         */
        userIdCel: string;
    } | {
        oneofKind: "userRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2;
         */
        userRef: UserRef;
    } | {
        oneofKind: "useSubjectUser";
        /**
         * @generated from protobuf field: bool use_subject_user = 3;
         */
        useSubjectUser: boolean;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: inclusion
     */
    inclusion: {
        oneofKind: "inclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionList inclusion_list = 4;
         */
        inclusionList: EntitlementInclusionList;
    } | {
        oneofKind: "inclusionAll";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionAll inclusion_all = 5;
         */
        inclusionAll: EntitlementInclusionAll;
    } | {
        oneofKind: "inclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria = 6;
         */
        inclusionCriteria: EntitlementInclusionCriteria;
    } | {
        oneofKind: "inclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel = 20;
         */
        inclusionListCel: EntitlementInclusionListCel;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: exclusion
     */
    exclusion: {
        oneofKind: "exclusionNone";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionNone exclusion_none = 7;
         */
        exclusionNone: EntitlementExclusionNone;
    } | {
        oneofKind: "exclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionList exclusion_list = 8;
         */
        exclusionList: EntitlementExclusionList;
    } | {
        oneofKind: "exclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionCriteria exclusion_criteria = 9;
         */
        exclusionCriteria: EntitlementExclusionCriteria;
    } | {
        oneofKind: "exclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementExclusionListCel exclusion_list_cel = 30;
         */
        exclusionListCel: EntitlementExclusionListCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionAll
 */
export interface EntitlementInclusionAll {
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionList
 */
export interface EntitlementInclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1;
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionCriteria
 */
export interface EntitlementInclusionCriteria {
    /**
     * @generated from protobuf field: repeated string app_ids = 1;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 2;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 3;
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 4;
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementInclusionListCel
 */
export interface EntitlementInclusionListCel {
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 1;
     */
    appEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionNone
 */
export interface EntitlementExclusionNone {
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionList
 */
export interface EntitlementExclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 1;
     */
    excludedAppEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionCriteria
 */
export interface EntitlementExclusionCriteria {
    /**
     * @generated from protobuf field: repeated string excluded_app_ids = 1;
     */
    excludedAppIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_resource_type_ids = 2;
     */
    excludedResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_risk_level_ids = 3;
     */
    excludedRiskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_compliance_framework_ids = 4;
     */
    excludedComplianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.EntitlementExclusionListCel
 */
export interface EntitlementExclusionListCel {
    /**
     * @generated from protobuf field: string excluded_app_entitlement_refs_cel = 1;
     */
    excludedAppEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlements
 */
export interface GrantEntitlements {
    /**
     * @generated from protobuf field: string user_id_cel = 1;
     */
    userIdCel: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2;
     */
    userRef?: UserRef;
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 3;
     */
    appEntitlementRefsCel: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 4;
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 5;
     */
    useSubjectUser: boolean;
    /**
     * @generated from protobuf oneof: inclusion
     */
    inclusion: {
        oneofKind: "inclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementInclusionList inclusion_list = 10;
         */
        inclusionList: GrantEntitlementInclusionList;
    } | {
        oneofKind: "inclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementInclusionCriteria inclusion_criteria = 11;
         */
        inclusionCriteria: GrantEntitlementInclusionCriteria;
    } | {
        oneofKind: "inclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementInclusionListCel inclusion_list_cel = 12;
         */
        inclusionListCel: GrantEntitlementInclusionListCel;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: exclusion
     */
    exclusion: {
        oneofKind: "exclusionNone";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionNone exclusion_none = 20;
         */
        exclusionNone: GrantEntitlementExclusionNone;
    } | {
        oneofKind: "exclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionList exclusion_list = 21;
         */
        exclusionList: GrantEntitlementExclusionList;
    } | {
        oneofKind: "exclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionCriteria exclusion_criteria = 22;
         */
        exclusionCriteria: GrantEntitlementExclusionCriteria;
    } | {
        oneofKind: "exclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantEntitlementExclusionListCel exclusion_list_cel = 23;
         */
        exclusionListCel: GrantEntitlementExclusionListCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementInclusionList
 */
export interface GrantEntitlementInclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1;
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementInclusionCriteria
 */
export interface GrantEntitlementInclusionCriteria {
    /**
     * @generated from protobuf field: repeated string app_ids = 1;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 2;
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 3;
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementInclusionListCel
 */
export interface GrantEntitlementInclusionListCel {
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 1;
     */
    appEntitlementRefsCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionNone
 */
export interface GrantEntitlementExclusionNone {
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionList
 */
export interface GrantEntitlementExclusionList {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_app_entitlement_refs = 1;
     */
    excludedAppEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionCriteria
 */
export interface GrantEntitlementExclusionCriteria {
    /**
     * @generated from protobuf field: repeated string excluded_app_ids = 1;
     */
    excludedAppIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_risk_level_ids = 2;
     */
    excludedRiskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string excluded_compliance_framework_ids = 3;
     */
    excludedComplianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantEntitlementExclusionListCel
 */
export interface GrantEntitlementExclusionListCel {
    /**
     * @generated from protobuf field: string excluded_app_entitlement_refs_cel = 1;
     */
    excludedAppEntitlementRefsCel: string;
}
/**
 * RemoveFromDelegation: find all users that have the target user as their delegated user, and modify the delegation.
 *
 * @generated from protobuf message c1.api.automations.v1.RemoveFromDelegation
 */
export interface RemoveFromDelegation {
    /**
     * @generated from protobuf field: string user_id_cel = 1;
     */
    userIdCel: string;
    /**
     * Required only if user_id_cel is not provided.
     *
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2;
     */
    userRef?: UserRef;
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 3;
     */
    useSubjectUser: boolean;
    /**
     * @generated from protobuf oneof: replacement_user
     */
    replacementUser: {
        oneofKind: "replacementUserIdCel";
        /**
         * The user who will replace the target user's delegation
         *
         * @generated from protobuf field: string replacement_user_id_cel = 4;
         */
        replacementUserIdCel: string;
    } | {
        oneofKind: "replacementUserRef";
        /**
         * Required only if replacement_user_id_cel is not provided.
         *
         * @generated from protobuf field: c1.api.user.v1.UserRef replacement_user_ref = 5;
         */
        replacementUserRef: UserRef;
    } | {
        oneofKind: undefined;
    };
}
/**
 * RunAutomation: kick off the execution of an automation template.
 *
 * @generated from protobuf message c1.api.automations.v1.RunAutomation
 */
export interface RunAutomation {
    /**
     * @generated from protobuf oneof: automation_template
     */
    automationTemplate: {
        oneofKind: "automationTemplateRef";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AutomationTemplateRef automation_template_ref = 1;
         */
        automationTemplateRef: AutomationTemplateRef;
    } | {
        oneofKind: "automationTemplateIdCel";
        /**
         * @generated from protobuf field: string automation_template_id_cel = 2;
         */
        automationTemplateIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 3;
     */
    context?: AutomationContext;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UpdateUser
 */
export interface UpdateUser {
    /**
     * @generated from protobuf oneof: user
     */
    user: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 5;
         */
        userIdCel: string;
    } | {
        oneofKind: "userRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 6;
         */
        userRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: user_status
     */
    userStatus: {
        oneofKind: "userStatusEnum";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserStatus user_status_enum = 7;
         */
        userStatusEnum: UserStatus;
    } | {
        oneofKind: "userStatusCel";
        /**
         * @generated from protobuf field: string user_status_cel = 8;
         */
        userStatusCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 9;
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CloseAction
 */
export interface CloseAction {
    /**
     * @generated from protobuf oneof: user_identifier
     */
    userIdentifier: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 1;
         */
        userIdCel: string;
    } | {
        oneofKind: "userRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2;
         */
        userRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 3;
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ReassignAction
 */
export interface ReassignAction {
    /**
     * @generated from protobuf oneof: assignee_user_identifier
     */
    assigneeUserIdentifier: {
        oneofKind: "assigneeUserIdCel";
        /**
         * @generated from protobuf field: string assignee_user_id_cel = 1;
         */
        assigneeUserIdCel: string;
    } | {
        oneofKind: "assigneeUserRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef assignee_user_ref = 2;
         */
        assigneeUserRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: subject_user_identifier
     */
    subjectUserIdentifier: {
        oneofKind: "subjectUserIdCel";
        /**
         * @generated from protobuf field: string subject_user_id_cel = 3;
         */
        subjectUserIdCel: string;
    } | {
        oneofKind: "subjectUserRef";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserRef subject_user_ref = 4;
         */
        subjectUserRef: UserRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * If true, the step will use the subject user of the automation as the subject.
     *
     * @generated from protobuf field: bool use_subject_user = 5;
     */
    useSubjectUser: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.TaskAction
 */
export interface TaskAction {
    /**
     * @generated from protobuf oneof: action
     */
    action: {
        oneofKind: "close";
        /**
         * @generated from protobuf field: c1.api.automations.v1.CloseAction close = 1;
         */
        close: CloseAction;
    } | {
        oneofKind: "reassign";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ReassignAction reassign = 2;
         */
        reassign: ReassignAction;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.TaskType task_types = 3;
     */
    taskTypes: TaskType[];
    /**
     * @generated from protobuf field: c1.api.automations.v1.TaskUserRelation task_user_relation = 4;
     */
    taskUserRelation: TaskUserRelation;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationContext
 */
export interface AutomationContext {
    /**
     * @generated from protobuf field: google.protobuf.Struct context = 1;
     */
    context?: Struct;
}
/**
 * @generated from protobuf message c1.api.automations.v1.Webhook
 */
export interface Webhook {
    /**
     * @generated from protobuf oneof: webhook_identifier
     */
    webhookIdentifier: {
        oneofKind: "webhookId";
        /**
         * @generated from protobuf field: string webhook_id = 1;
         */
        webhookId: string;
    } | {
        oneofKind: "webhookIdCel";
        /**
         * @generated from protobuf field: string webhook_id_cel = 2;
         */
        webhookIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: google.protobuf.Struct payload = 3;
     */
    payload?: Struct;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ConnectorAction
 */
export interface ConnectorAction {
    /**
     * @generated from protobuf oneof: connector_identifier
     */
    connectorIdentifier: {
        oneofKind: "connectorRef";
        /**
         * @generated from protobuf field: c1.api.app.v1.ConnectorRef connector_ref = 1;
         */
        connectorRef: ConnectorRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string action_name = 2;
     */
    actionName: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct args_template = 3;
     */
    argsTemplate?: Struct;
    /**
     * @generated from protobuf field: string resource_type_id = 4;
     */
    resourceTypeId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccountLifecycleAction
 */
export interface AccountLifecycleAction {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorRef connector_ref = 1;
     */
    connectorRef?: ConnectorRef;
    /**
     * @generated from protobuf field: string action_name = 2;
     */
    actionName: string;
    /**
     * @generated from protobuf oneof: account_identifier
     */
    accountIdentifier: {
        oneofKind: "accountRef";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccountRef account_ref = 100;
         */
        accountRef: AccountRef;
    } | {
        oneofKind: "accountInContext";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccountInContext account_in_context = 101;
         */
        accountInContext: AccountInContext;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.GeneratePassword
 */
export interface GeneratePassword {
}
/**
 * @generated from protobuf message c1.api.automations.v1.EvaluateExpressions
 */
export interface EvaluateExpressions {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.Expression expressions = 1;
     */
    expressions: Expression[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.Expression
 */
export interface Expression {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string;
    /**
     * @generated from protobuf field: string expression_cel = 2;
     */
    expressionCel: string;
    /**
     * @generated from protobuf field: bool is_secret = 3;
     */
    isSecret: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccountInContext
 */
export interface AccountInContext {
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccountRef
 */
export interface AccountRef {
    /**
     * @generated from protobuf field: string account_id_cel = 1;
     */
    accountIdCel: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ConnectorCreateAccount
 */
export interface ConnectorCreateAccount {
    /**
     * @generated from protobuf field: c1.api.app.v1.ConnectorRef connector_ref = 1;
     */
    connectorRef?: ConnectorRef;
    /**
     * @generated from protobuf oneof: create_account_arguments
     */
    createAccountArguments: {
        oneofKind: "userIdCel";
        /**
         * @generated from protobuf field: string user_id_cel = 2;
         */
        userIdCel: string;
    } | {
        oneofKind: "userProperties";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserProperties user_properties = 3;
         */
        userProperties: UserProperties;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.UserProperties
 */
export interface UserProperties {
    /**
     * @generated from protobuf field: string display_name_cel = 1;
     */
    displayNameCel: string;
    /**
     * @generated from protobuf field: string email_cel = 2;
     */
    emailCel: string;
    /**
     * @generated from protobuf field: string username_cel = 3;
     */
    usernameCel: string;
    /**
     * @generated from protobuf field: string profile_attribute_cel = 4;
     */
    profileAttributeCel: string;
}
/**
 * Automation Triggers
 *
 * @generated from protobuf message c1.api.automations.v1.AutomationTrigger
 */
export interface AutomationTrigger {
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "manual";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ManualAutomationTrigger manual = 101;
         */
        manual: ManualAutomationTrigger;
    } | {
        oneofKind: "userProfileChange";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserProfileChangeTrigger user_profile_change = 102;
         */
        userProfileChange: UserProfileChangeTrigger;
    } | {
        oneofKind: "appUserCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserCreatedTrigger app_user_created = 103;
         */
        appUserCreated: AppUserCreatedTrigger;
    } | {
        oneofKind: "appUserUpdated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated = 104;
         */
        appUserUpdated: AppUserUpdatedTrigger;
    } | {
        oneofKind: "usageBasedRevocation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation = 105;
         */
        usageBasedRevocation: UsageBasedRevocationTrigger;
    } | {
        oneofKind: "userCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserCreatedTrigger user_created = 106;
         */
        userCreated: UserCreatedTrigger;
    } | {
        oneofKind: "grantFound";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantFoundTrigger grant_found = 107;
         */
        grantFound: GrantFoundTrigger;
    } | {
        oneofKind: "grantDeleted";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantDeletedTrigger grant_deleted = 108;
         */
        grantDeleted: GrantDeletedTrigger;
    } | {
        oneofKind: "webhook";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WebhookAutomationTrigger webhook = 109;
         */
        webhook: WebhookAutomationTrigger;
    } | {
        oneofKind: "schedule";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTrigger schedule = 110;
         */
        schedule: ScheduleTrigger;
    } | {
        oneofKind: "form";
        /**
         * @generated from protobuf field: c1.api.automations.v1.FormTrigger form = 111;
         */
        form: FormTrigger;
    } | {
        oneofKind: "scheduleAppUser";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user = 112;
         */
        scheduleAppUser: ScheduleTriggerAppUser;
    } | {
        oneofKind: "accessConflict";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AccessConflictTrigger access_conflict = 113;
         */
        accessConflict: AccessConflictTrigger;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.ManualAutomationTrigger
 */
export interface ManualAutomationTrigger {
}
/**
 * @generated from protobuf message c1.api.automations.v1.UserProfileChangeTrigger
 */
export interface UserProfileChangeTrigger {
    /**
     * @generated from protobuf field: string condition = 3;
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UserCreatedTrigger
 */
export interface UserCreatedTrigger {
    /**
     * @generated from protobuf field: string condition = 1;
     */
    condition: string; // CEL expression that must evaluate to true for the trigger to fire
}
/**
 * @generated from protobuf message c1.api.automations.v1.AppUserCreatedTrigger
 */
export interface AppUserCreatedTrigger {
    /**
     * @generated from protobuf oneof: app_identifier
     */
    appIdentifier: {
        oneofKind: "appId";
        /**
         * @generated from protobuf field: string app_id = 1;
         */
        appId: string;
    } | {
        oneofKind: "appIdCel";
        /**
         * @generated from protobuf field: string app_id_cel = 2;
         */
        appIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string condition = 3;
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AppUserUpdatedTrigger
 */
export interface AppUserUpdatedTrigger {
    /**
     * @generated from protobuf oneof: app_identifier
     */
    appIdentifier: {
        oneofKind: "appId";
        /**
         * @generated from protobuf field: string app_id = 1;
         */
        appId: string;
    } | {
        oneofKind: "appIdCel";
        /**
         * @generated from protobuf field: string app_id_cel = 2;
         */
        appIdCel: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string condition = 3;
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.UsageBasedRevocationTrigger
 */
export interface UsageBasedRevocationTrigger {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp enabled_at = 2;
     */
    enabledAt?: Timestamp;
    /**
     * @generated from protobuf field: uint32 unused_for_days = 3;
     */
    unusedForDays: number;
    /**
     * @generated from protobuf field: bool include_users_with_no_activity = 4;
     */
    includeUsersWithNoActivity: boolean;
    /**
     * @generated from protobuf oneof: cold_start_schedule
     */
    coldStartSchedule: {
        oneofKind: "runImmediately";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RunImmediately run_immediately = 100;
         */
        runImmediately: RunImmediately;
    } | {
        oneofKind: "runDelayed";
        /**
         * @generated from protobuf field: c1.api.automations.v1.RunDelayed run_delayed = 101;
         */
        runDelayed: RunDelayed;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType targeted_app_user_types = 7;
     */
    targetedAppUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef targeted_entitlement_refs = 8;
     */
    targetedEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_group_refs = 9;
     */
    excludedGroupRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef excluded_user_refs = 10;
     */
    excludedUserRefs: UserRef[];
}
/**
 * No fields needed; this just indicates the trigger should run immediately
 *
 * @generated from protobuf message c1.api.automations.v1.RunImmediately
 */
export interface RunImmediately {
}
/**
 * @generated from protobuf message c1.api.automations.v1.RunDelayed
 */
export interface RunDelayed {
    /**
     * @generated from protobuf field: uint32 cold_start_delay_days = 1;
     */
    coldStartDelayDays: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter
 */
export interface GrantTriggerFilter {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter.GrantFilter grant_filter = 1;
     */
    grantFilter?: GrantTriggerFilter_GrantFilter;
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter.EntitlementFilter entitlement_filter = 2;
     */
    entitlementFilter?: GrantTriggerFilter_EntitlementFilter;
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter.AccountFilter account_filter = 3;
     */
    accountFilter?: GrantTriggerFilter_AccountFilter;
    /**
     * @generated from protobuf oneof: entitlement_inclusion
     */
    entitlementInclusion: {
        oneofKind: "inclusionList";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionList inclusion_list = 4;
         */
        inclusionList: EntitlementInclusionList;
    } | {
        oneofKind: "inclusionAll";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionAll inclusion_all = 5;
         */
        inclusionAll: EntitlementInclusionAll;
    } | {
        oneofKind: "inclusionCriteria";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionCriteria inclusion_criteria = 6;
         */
        inclusionCriteria: EntitlementInclusionCriteria;
    } | {
        oneofKind: "inclusionListCel";
        /**
         * @generated from protobuf field: c1.api.automations.v1.EntitlementInclusionListCel inclusion_list_cel = 7;
         */
        inclusionListCel: EntitlementInclusionListCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter.GrantFilter
 */
export interface GrantTriggerFilter_GrantFilter {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantSourceFilter grant_source_filter = 101;
     */
    grantSourceFilter: GrantSourceFilter;
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantFilterType grant_filter_type = 102;
     */
    grantFilterType: GrantFilterType;
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantJustificationType grant_justification_type = 103;
     */
    grantJustificationType: GrantJustificationType;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter.EntitlementFilter
 */
export interface GrantTriggerFilter_EntitlementFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 201;
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string app_entitlement_refs_cel = 202;
     */
    appEntitlementRefsCel: string;
    /**
     * @generated from protobuf field: string app_id = 203;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantTriggerFilter.AccountFilter
 */
export interface GrantTriggerFilter_AccountFilter {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserType account_type = 301;
     */
    accountType: AppUserType;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantFoundTrigger
 */
export interface GrantFoundTrigger {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter = 1;
     */
    grantTriggerFilter?: GrantTriggerFilter;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GrantDeletedTrigger
 */
export interface GrantDeletedTrigger {
    /**
     * @generated from protobuf field: c1.api.automations.v1.GrantTriggerFilter grant_trigger_filter = 1;
     */
    grantTriggerFilter?: GrantTriggerFilter;
}
/**
 * @generated from protobuf message c1.api.automations.v1.WebhookAutomationTrigger
 */
export interface WebhookAutomationTrigger {
    /**
     * @generated from protobuf oneof: auth_config
     */
    authConfig: {
        oneofKind: "jwt";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WebhookListenerAuthJWT jwt = 1;
         */
        jwt: WebhookListenerAuthJWT;
    } | {
        oneofKind: "hmac";
        /**
         * @generated from protobuf field: c1.api.automations.v1.WebhookListenerAuthHMAC hmac = 2;
         */
        hmac: WebhookListenerAuthHMAC;
    } | {
        oneofKind: undefined;
    };
    /**
     * Optional existing listener ID (hidden field from frontend)
     *
     * @generated from protobuf field: string listener_id = 3;
     */
    listenerId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.FormTrigger
 */
export interface FormTrigger {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1;
     */
    form?: Form;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ConflictMonitorRefs
 */
export interface ConflictMonitorRefs {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorRef conflict_monitor_refs = 1;
     */
    conflictMonitorRefs: ConflictMonitorRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.AccessConflictTrigger
 */
export interface AccessConflictTrigger {
    /**
     * @generated from protobuf oneof: conflict_monitor_selector
     */
    conflictMonitorSelector: {
        oneofKind: "conflictMonitorRefs";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ConflictMonitorRefs conflict_monitor_refs = 100;
         */
        conflictMonitorRefs: ConflictMonitorRefs;
    } | {
        oneofKind: "allConflictMonitors";
        /**
         * @generated from protobuf field: bool all_conflict_monitors = 101;
         */
        allConflictMonitors: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.WebhookListenerAuthJWT
 */
export interface WebhookListenerAuthJWT {
    /**
     * @generated from protobuf field: string jwks_url = 1;
     */
    jwksUrl: string;
}
/**
 * This will be generated and encrypted by the backend
 * Frontend should not populate this field directly
 *
 * @generated from protobuf message c1.api.automations.v1.WebhookListenerAuthHMAC
 */
export interface WebhookListenerAuthHMAC {
}
/**
 * @generated from protobuf message c1.api.automations.v1.ScheduleTrigger
 */
export interface ScheduleTrigger {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: string cron_spec = 2;
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: bool advanced = 3;
     */
    advanced: boolean;
    /**
     * @deprecated
     * @generated from protobuf field: string skip_if_true_cel = 4 [deprecated = true];
     */
    skipIfTrueCel: string;
    /**
     * @generated from protobuf field: string condition = 5;
     */
    condition: string;
    /**
     * @generated from protobuf field: string timezone = 6;
     */
    timezone: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ScheduleTriggerAppUser
 */
export interface ScheduleTriggerAppUser {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: string cron_spec = 2;
     */
    cronSpec: string;
    /**
     * @generated from protobuf field: string condition = 3;
     */
    condition: string;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string timezone = 5;
     */
    timezone: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationTemplateVersion
 */
export interface AutomationTemplateVersion {
    /**
     * @generated from protobuf field: string automation_template_id = 1;
     */
    automationTemplateId: string;
    /**
     * @generated from protobuf field: int64 version = 2;
     */
    version: number;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationStep automation_steps = 3;
     */
    automationSteps: AutomationStep[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationTrigger triggers = 4;
     */
    triggers: AutomationTrigger[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.automations.v1.TriggerType
 */
export enum TriggerType {
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_USER_PROFILE_CHANGE = 2;
     */
    USER_PROFILE_CHANGE = 2,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_APP_USER_CREATE = 3;
     */
    APP_USER_CREATE = 3,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_APP_USER_UPDATE = 4;
     */
    APP_USER_UPDATE = 4,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_UNUSED_ACCESS = 5;
     */
    UNUSED_ACCESS = 5,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_USER_CREATED = 6;
     */
    USER_CREATED = 6,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_GRANT_FOUND = 7;
     */
    GRANT_FOUND = 7,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_GRANT_DELETED = 8;
     */
    GRANT_DELETED = 8,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_WEBHOOK = 9;
     */
    WEBHOOK = 9,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_SCHEDULE = 10;
     */
    SCHEDULE = 10,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_FORM = 11;
     */
    FORM = 11,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_SCHEDULE_APP_USER = 12;
     */
    SCHEDULE_APP_USER = 12,
    /**
     * @generated from protobuf enum value: TRIGGER_TYPE_ACCESS_CONFLICT = 13;
     */
    ACCESS_CONFLICT = 13
}
/**
 * @generated from protobuf enum c1.api.automations.v1.TaskType
 */
export enum TaskType {
    /**
     * @generated from protobuf enum value: TASK_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_TYPE_REQUEST = 1;
     */
    REQUEST = 1,
    /**
     * @generated from protobuf enum value: TASK_TYPE_REVOKE = 2;
     */
    REVOKE = 2,
    /**
     * @generated from protobuf enum value: TASK_TYPE_REVIEW = 3;
     */
    REVIEW = 3
}
/**
 * @generated from protobuf enum c1.api.automations.v1.TaskUserRelation
 */
export enum TaskUserRelation {
    /**
     * @generated from protobuf enum value: TASK_USER_RELATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * tasks assigned to user
     *
     * @generated from protobuf enum value: TASK_USER_RELATION_ASSIGNEE = 1;
     */
    ASSIGNEE = 1,
    /**
     * tasks for user
     *
     * @generated from protobuf enum value: TASK_USER_RELATION_SUBJECT = 2;
     */
    SUBJECT = 2
}
/**
 * @generated from protobuf enum c1.api.automations.v1.GrantFilterType
 */
export enum GrantFilterType {
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_PERMANENT = 1;
     */
    PERMANENT = 1,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_TEMPORARY = 2;
     */
    TEMPORARY = 2
}
/**
 * @generated from protobuf enum c1.api.automations.v1.GrantSourceFilter
 */
export enum GrantSourceFilter {
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_DIRECT = 1;
     */
    DIRECT = 1,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_INHERITED = 2;
     */
    INHERITED = 2
}
/**
 * @generated from protobuf enum c1.api.automations.v1.GrantJustificationType
 */
export enum GrantJustificationType {
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_ALL = 1;
     */
    ALL = 1,
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_CONDUCTOR_ONE = 2;
     */
    CONDUCTOR_ONE = 2,
    /**
     * @generated from protobuf enum value: GRANT_JUSTIFICATION_TYPE_DIRECT = 3;
     */
    DIRECT = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationsRequest$Type extends MessageType<SearchAutomationsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTemplateRef },
            { no: 5, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "trigger_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.TriggerType", TriggerType, "TRIGGER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationsRequest
 */
export const SearchAutomationsRequest = new SearchAutomationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationsResponse$Type extends MessageType<SearchAutomationsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Automation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationsResponse
 */
export const SearchAutomationsResponse = new SearchAutomationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationTemplateVersionsRequest$Type extends MessageType<SearchAutomationTemplateVersionsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationTemplateVersionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsRequest
 */
export const SearchAutomationTemplateVersionsRequest = new SearchAutomationTemplateVersionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationTemplateVersionsResponse$Type extends MessageType<SearchAutomationTemplateVersionsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationTemplateVersionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTemplateVersion },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationTemplateVersionsResponse
 */
export const SearchAutomationTemplateVersionsResponse = new SearchAutomationTemplateVersionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationRequest$Type extends MessageType<GetAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationRequest
 */
export const GetAutomationRequest = new GetAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationResponse$Type extends MessageType<GetAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => Automation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationResponse
 */
export const GetAutomationResponse = new GetAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationRequest$Type extends MessageType<CreateAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.CreateAutomationRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "context", kind: "message", T: () => AutomationContext },
            { no: 5, name: "automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "15" } } } },
            { no: 6, name: "triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 7, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 8, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "draft_automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 10, name: "draft_triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateAutomationRequest
 */
export const CreateAutomationRequest = new CreateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationResponse$Type extends MessageType<CreateAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.CreateAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => Automation },
            { no: 2, name: "webhook_hmac_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateAutomationResponse
 */
export const CreateAutomationResponse = new CreateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExecuteAutomationRequest$Type extends MessageType<ExecuteAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.ExecuteAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "context", kind: "message", T: () => AutomationContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ExecuteAutomationRequest
 */
export const ExecuteAutomationRequest = new ExecuteAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExecuteAutomationResponse$Type extends MessageType<ExecuteAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.ExecuteAutomationResponse", [
            { no: 1, name: "execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ExecuteAutomationResponse
 */
export const ExecuteAutomationResponse = new ExecuteAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAutomationRequest$Type extends MessageType<UpdateAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.UpdateAutomationRequest", [
            { no: 1, name: "automation", kind: "message", T: () => Automation },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UpdateAutomationRequest
 */
export const UpdateAutomationRequest = new UpdateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAutomationResponse$Type extends MessageType<UpdateAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.UpdateAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => Automation },
            { no: 2, name: "webhook_hmac_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UpdateAutomationResponse
 */
export const UpdateAutomationResponse = new UpdateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationRequest$Type extends MessageType<DeleteAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.DeleteAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.DeleteAutomationRequest
 */
export const DeleteAutomationRequest = new DeleteAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationResponse$Type extends MessageType<DeleteAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.DeleteAutomationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.DeleteAutomationResponse
 */
export const DeleteAutomationResponse = new DeleteAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationsRequest$Type extends MessageType<ListAutomationsRequest> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationsRequest
 */
export const ListAutomationsRequest = new ListAutomationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationsResponse$Type extends MessageType<ListAutomationsResponse> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Automation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationsResponse
 */
export const ListAutomationsResponse = new ListAutomationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Automation$Type extends MessageType<Automation> {
    constructor() {
        super("c1.api.automations.v1.Automation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 101, name: "circuit_breaker", kind: "message", oneof: "disabledReason", T: () => DisabledReasonCircuitBreaker },
            { no: 5, name: "context", kind: "message", T: () => AutomationContext },
            { no: 6, name: "automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 7, name: "triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 15, name: "primary_trigger_type", kind: "enum", T: () => ["c1.api.automations.v1.TriggerType", TriggerType, "TRIGGER_TYPE_"], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 8, name: "last_executed_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "draft_automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 11, name: "draft_triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 12, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "current_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 14, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Automation" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.Automation
 */
export const Automation = new Automation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisabledReasonCircuitBreaker$Type extends MessageType<DisabledReasonCircuitBreaker> {
    constructor() {
        super("c1.api.automations.v1.DisabledReasonCircuitBreaker", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.DisabledReasonCircuitBreaker
 */
export const DisabledReasonCircuitBreaker = new DisabledReasonCircuitBreaker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationTemplateRef$Type extends MessageType<AutomationTemplateRef> {
    constructor() {
        super("c1.api.automations.v1.AutomationTemplateRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationTemplateRef
 */
export const AutomationTemplateRef = new AutomationTemplateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationStep$Type extends MessageType<AutomationStep> {
    constructor() {
        super("c1.api.automations.v1.AutomationStep", [
            { no: 1, name: "step_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 101, name: "create_access_review", kind: "message", oneof: "kind", T: () => CreateAccessReview },
            { no: 102, name: "wait_for_duration", kind: "message", oneof: "kind", T: () => WaitForDuration },
            { no: 103, name: "unenroll_from_all_access_profiles", kind: "message", oneof: "kind", T: () => UnenrollFromAllAccessProfiles },
            { no: 104, name: "create_revoke_tasks", kind: "message", oneof: "kind", T: () => CreateRevokeTasks },
            { no: 117, name: "create_revoke_tasks_v2", kind: "message", oneof: "kind", T: () => CreateRevokeTasksV2 },
            { no: 105, name: "send_email", kind: "message", oneof: "kind", T: () => SendEmail },
            { no: 106, name: "remove_from_delegation", kind: "message", oneof: "kind", T: () => RemoveFromDelegation },
            { no: 107, name: "run_automation", kind: "message", oneof: "kind", T: () => RunAutomation },
            { no: 108, name: "update_user", kind: "message", oneof: "kind", T: () => UpdateUser },
            { no: 109, name: "task_action", kind: "message", oneof: "kind", T: () => TaskAction },
            { no: 110, name: "webhook", kind: "message", oneof: "kind", T: () => Webhook },
            { no: 111, name: "connector_action", kind: "message", oneof: "kind", T: () => ConnectorAction },
            { no: 112, name: "connector_create_account", kind: "message", oneof: "kind", T: () => ConnectorCreateAccount },
            { no: 113, name: "grant_entitlements", kind: "message", oneof: "kind", T: () => GrantEntitlements },
            { no: 114, name: "send_slack_message", kind: "message", oneof: "kind", T: () => SendSlackMessage },
            { no: 115, name: "call_function", kind: "message", oneof: "kind", T: () => CallFunction },
            { no: 116, name: "account_lifecycle_action", kind: "message", oneof: "kind", T: () => AccountLifecycleAction },
            { no: 120, name: "generate_password", kind: "message", oneof: "kind", T: () => GeneratePassword },
            { no: 121, name: "evaluate_expressions", kind: "message", oneof: "kind", T: () => EvaluateExpressions },
            { no: 2, name: "skip_if_true_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "step_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationStep
 */
export const AutomationStep = new AutomationStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendEmail$Type extends MessageType<SendEmail> {
    constructor() {
        super("c1.api.automations.v1.SendEmail", [
            { no: 1, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "user_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SendEmail
 */
export const SendEmail = new SendEmail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendSlackMessage$Type extends MessageType<SendSlackMessage> {
    constructor() {
        super("c1.api.automations.v1.SendSlackMessage", [
            { no: 1, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "channel_name", kind: "scalar", oneof: "channel", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "channel_name_cel", kind: "scalar", oneof: "channel", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SendSlackMessage
 */
export const SendSlackMessage = new SendSlackMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallFunction$Type extends MessageType<CallFunction> {
    constructor() {
        super("c1.api.automations.v1.CallFunction", [
            { no: 1, name: "function_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "args", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CallFunction
 */
export const CallFunction = new CallFunction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessReview$Type extends MessageType<CreateAccessReview> {
    constructor() {
        super("c1.api.automations.v1.CreateAccessReview", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_template_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "campaign_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateAccessReview
 */
export const CreateAccessReview = new CreateAccessReview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitForDuration$Type extends MessageType<WaitForDuration> {
    constructor() {
        super("c1.api.automations.v1.WaitForDuration", [
            { no: 1, name: "duration", kind: "message", T: () => Duration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WaitForDuration
 */
export const WaitForDuration = new WaitForDuration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnenrollFromAllAccessProfiles$Type extends MessageType<UnenrollFromAllAccessProfiles> {
    constructor() {
        super("c1.api.automations.v1.UnenrollFromAllAccessProfiles", [
            { no: 1, name: "user_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 3, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "catalog_ids_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UnenrollFromAllAccessProfiles
 */
export const UnenrollFromAllAccessProfiles = new UnenrollFromAllAccessProfiles$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRevokeTasks$Type extends MessageType<CreateRevokeTasks> {
    constructor() {
        super("c1.api.automations.v1.CreateRevokeTasks", [
            { no: 1, name: "user_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "revoke_all", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "excluded_app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 8, name: "excluded_app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateRevokeTasks
 */
export const CreateRevokeTasks = new CreateRevokeTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRevokeTasksV2$Type extends MessageType<CreateRevokeTasksV2> {
    constructor() {
        super("c1.api.automations.v1.CreateRevokeTasksV2", [
            { no: 1, name: "user_id_cel", kind: "scalar", oneof: "user", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", oneof: "user", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "use_subject_user", kind: "scalar", oneof: "user", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "inclusion_list", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionList },
            { no: 5, name: "inclusion_all", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionAll },
            { no: 6, name: "inclusion_criteria", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionCriteria },
            { no: 20, name: "inclusion_list_cel", kind: "message", oneof: "inclusion", T: () => EntitlementInclusionListCel },
            { no: 7, name: "exclusion_none", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionNone },
            { no: 8, name: "exclusion_list", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionList },
            { no: 9, name: "exclusion_criteria", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionCriteria },
            { no: 30, name: "exclusion_list_cel", kind: "message", oneof: "exclusion", T: () => EntitlementExclusionListCel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CreateRevokeTasksV2
 */
export const CreateRevokeTasksV2 = new CreateRevokeTasksV2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionAll$Type extends MessageType<EntitlementInclusionAll> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionAll", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionAll
 */
export const EntitlementInclusionAll = new EntitlementInclusionAll$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionList$Type extends MessageType<EntitlementInclusionList> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionList", [
            { no: 1, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionList
 */
export const EntitlementInclusionList = new EntitlementInclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionCriteria$Type extends MessageType<EntitlementInclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionCriteria", [
            { no: 1, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 3, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionCriteria
 */
export const EntitlementInclusionCriteria = new EntitlementInclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementInclusionListCel$Type extends MessageType<EntitlementInclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.EntitlementInclusionListCel", [
            { no: 1, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementInclusionListCel
 */
export const EntitlementInclusionListCel = new EntitlementInclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionNone$Type extends MessageType<EntitlementExclusionNone> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionNone", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionNone
 */
export const EntitlementExclusionNone = new EntitlementExclusionNone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionList$Type extends MessageType<EntitlementExclusionList> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionList", [
            { no: 1, name: "excluded_app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionList
 */
export const EntitlementExclusionList = new EntitlementExclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionCriteria$Type extends MessageType<EntitlementExclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionCriteria", [
            { no: 1, name: "excluded_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "excluded_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 3, name: "excluded_risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "excluded_compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionCriteria
 */
export const EntitlementExclusionCriteria = new EntitlementExclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementExclusionListCel$Type extends MessageType<EntitlementExclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.EntitlementExclusionListCel", [
            { no: 1, name: "excluded_app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EntitlementExclusionListCel
 */
export const EntitlementExclusionListCel = new EntitlementExclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlements$Type extends MessageType<GrantEntitlements> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlements", [
            { no: 1, name: "user_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "inclusion_list", kind: "message", oneof: "inclusion", T: () => GrantEntitlementInclusionList },
            { no: 11, name: "inclusion_criteria", kind: "message", oneof: "inclusion", T: () => GrantEntitlementInclusionCriteria },
            { no: 12, name: "inclusion_list_cel", kind: "message", oneof: "inclusion", T: () => GrantEntitlementInclusionListCel },
            { no: 20, name: "exclusion_none", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionNone },
            { no: 21, name: "exclusion_list", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionList },
            { no: 22, name: "exclusion_criteria", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionCriteria },
            { no: 23, name: "exclusion_list_cel", kind: "message", oneof: "exclusion", T: () => GrantEntitlementExclusionListCel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlements
 */
export const GrantEntitlements = new GrantEntitlements$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementInclusionList$Type extends MessageType<GrantEntitlementInclusionList> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementInclusionList", [
            { no: 1, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementInclusionList
 */
export const GrantEntitlementInclusionList = new GrantEntitlementInclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementInclusionCriteria$Type extends MessageType<GrantEntitlementInclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementInclusionCriteria", [
            { no: 1, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementInclusionCriteria
 */
export const GrantEntitlementInclusionCriteria = new GrantEntitlementInclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementInclusionListCel$Type extends MessageType<GrantEntitlementInclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementInclusionListCel", [
            { no: 1, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementInclusionListCel
 */
export const GrantEntitlementInclusionListCel = new GrantEntitlementInclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionNone$Type extends MessageType<GrantEntitlementExclusionNone> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionNone", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionNone
 */
export const GrantEntitlementExclusionNone = new GrantEntitlementExclusionNone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionList$Type extends MessageType<GrantEntitlementExclusionList> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionList", [
            { no: 1, name: "excluded_app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionList
 */
export const GrantEntitlementExclusionList = new GrantEntitlementExclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionCriteria$Type extends MessageType<GrantEntitlementExclusionCriteria> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionCriteria", [
            { no: 1, name: "excluded_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "excluded_risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "excluded_compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionCriteria
 */
export const GrantEntitlementExclusionCriteria = new GrantEntitlementExclusionCriteria$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantEntitlementExclusionListCel$Type extends MessageType<GrantEntitlementExclusionListCel> {
    constructor() {
        super("c1.api.automations.v1.GrantEntitlementExclusionListCel", [
            { no: 1, name: "excluded_app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "8192" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantEntitlementExclusionListCel
 */
export const GrantEntitlementExclusionListCel = new GrantEntitlementExclusionListCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveFromDelegation$Type extends MessageType<RemoveFromDelegation> {
    constructor() {
        super("c1.api.automations.v1.RemoveFromDelegation", [
            { no: 1, name: "user_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "replacement_user_id_cel", kind: "scalar", oneof: "replacementUser", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "replacement_user_ref", kind: "message", oneof: "replacementUser", T: () => UserRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RemoveFromDelegation
 */
export const RemoveFromDelegation = new RemoveFromDelegation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunAutomation$Type extends MessageType<RunAutomation> {
    constructor() {
        super("c1.api.automations.v1.RunAutomation", [
            { no: 1, name: "automation_template_ref", kind: "message", oneof: "automationTemplate", T: () => AutomationTemplateRef },
            { no: 2, name: "automation_template_id_cel", kind: "scalar", oneof: "automationTemplate", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "context", kind: "message", T: () => AutomationContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RunAutomation
 */
export const RunAutomation = new RunAutomation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUser$Type extends MessageType<UpdateUser> {
    constructor() {
        super("c1.api.automations.v1.UpdateUser", [
            { no: 5, name: "user_id_cel", kind: "scalar", oneof: "user", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_ref", kind: "message", oneof: "user", T: () => UserRef },
            { no: 7, name: "user_status_enum", kind: "enum", oneof: "userStatus", T: () => ["c1.api.user.v1.UserStatus", UserStatus] },
            { no: 8, name: "user_status_cel", kind: "scalar", oneof: "userStatus", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UpdateUser
 */
export const UpdateUser = new UpdateUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseAction$Type extends MessageType<CloseAction> {
    constructor() {
        super("c1.api.automations.v1.CloseAction", [
            { no: 1, name: "user_id_cel", kind: "scalar", oneof: "userIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_ref", kind: "message", oneof: "userIdentifier", T: () => UserRef },
            { no: 3, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CloseAction
 */
export const CloseAction = new CloseAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReassignAction$Type extends MessageType<ReassignAction> {
    constructor() {
        super("c1.api.automations.v1.ReassignAction", [
            { no: 1, name: "assignee_user_id_cel", kind: "scalar", oneof: "assigneeUserIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "assignee_user_ref", kind: "message", oneof: "assigneeUserIdentifier", T: () => UserRef },
            { no: 3, name: "subject_user_id_cel", kind: "scalar", oneof: "subjectUserIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subject_user_ref", kind: "message", oneof: "subjectUserIdentifier", T: () => UserRef },
            { no: 5, name: "use_subject_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ReassignAction
 */
export const ReassignAction = new ReassignAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAction$Type extends MessageType<TaskAction> {
    constructor() {
        super("c1.api.automations.v1.TaskAction", [
            { no: 1, name: "close", kind: "message", oneof: "action", T: () => CloseAction },
            { no: 2, name: "reassign", kind: "message", oneof: "action", T: () => ReassignAction },
            { no: 3, name: "task_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.TaskType", TaskType, "TASK_TYPE_"] },
            { no: 4, name: "task_user_relation", kind: "enum", T: () => ["c1.api.automations.v1.TaskUserRelation", TaskUserRelation, "TASK_USER_RELATION_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.TaskAction
 */
export const TaskAction = new TaskAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationContext$Type extends MessageType<AutomationContext> {
    constructor() {
        super("c1.api.automations.v1.AutomationContext", [
            { no: 1, name: "context", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationContext
 */
export const AutomationContext = new AutomationContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Webhook$Type extends MessageType<Webhook> {
    constructor() {
        super("c1.api.automations.v1.Webhook", [
            { no: 1, name: "webhook_id", kind: "scalar", oneof: "webhookIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_id_cel", kind: "scalar", oneof: "webhookIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "payload", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.Webhook
 */
export const Webhook = new Webhook$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAction$Type extends MessageType<ConnectorAction> {
    constructor() {
        super("c1.api.automations.v1.ConnectorAction", [
            { no: 1, name: "connector_ref", kind: "message", oneof: "connectorIdentifier", T: () => ConnectorRef },
            { no: 2, name: "action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "args_template", kind: "message", T: () => Struct },
            { no: 4, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ConnectorAction
 */
export const ConnectorAction = new ConnectorAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountLifecycleAction$Type extends MessageType<AccountLifecycleAction> {
    constructor() {
        super("c1.api.automations.v1.AccountLifecycleAction", [
            { no: 1, name: "connector_ref", kind: "message", T: () => ConnectorRef },
            { no: 2, name: "action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "account_ref", kind: "message", oneof: "accountIdentifier", T: () => AccountRef },
            { no: 101, name: "account_in_context", kind: "message", oneof: "accountIdentifier", T: () => AccountInContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccountLifecycleAction
 */
export const AccountLifecycleAction = new AccountLifecycleAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePassword$Type extends MessageType<GeneratePassword> {
    constructor() {
        super("c1.api.automations.v1.GeneratePassword", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GeneratePassword
 */
export const GeneratePassword = new GeneratePassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EvaluateExpressions$Type extends MessageType<EvaluateExpressions> {
    constructor() {
        super("c1.api.automations.v1.EvaluateExpressions", [
            { no: 1, name: "expressions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Expression }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.EvaluateExpressions
 */
export const EvaluateExpressions = new EvaluateExpressions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Expression$Type extends MessageType<Expression> {
    constructor() {
        super("c1.api.automations.v1.Expression", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expression_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.Expression
 */
export const Expression = new Expression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInContext$Type extends MessageType<AccountInContext> {
    constructor() {
        super("c1.api.automations.v1.AccountInContext", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccountInContext
 */
export const AccountInContext = new AccountInContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountRef$Type extends MessageType<AccountRef> {
    constructor() {
        super("c1.api.automations.v1.AccountRef", [
            { no: 1, name: "account_id_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccountRef
 */
export const AccountRef = new AccountRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCreateAccount$Type extends MessageType<ConnectorCreateAccount> {
    constructor() {
        super("c1.api.automations.v1.ConnectorCreateAccount", [
            { no: 1, name: "connector_ref", kind: "message", T: () => ConnectorRef },
            { no: 2, name: "user_id_cel", kind: "scalar", oneof: "createAccountArguments", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_properties", kind: "message", oneof: "createAccountArguments", T: () => UserProperties }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ConnectorCreateAccount
 */
export const ConnectorCreateAccount = new ConnectorCreateAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProperties$Type extends MessageType<UserProperties> {
    constructor() {
        super("c1.api.automations.v1.UserProperties", [
            { no: 1, name: "display_name_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "username_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile_attribute_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UserProperties
 */
export const UserProperties = new UserProperties$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationTrigger$Type extends MessageType<AutomationTrigger> {
    constructor() {
        super("c1.api.automations.v1.AutomationTrigger", [
            { no: 101, name: "manual", kind: "message", oneof: "kind", T: () => ManualAutomationTrigger },
            { no: 102, name: "user_profile_change", kind: "message", oneof: "kind", T: () => UserProfileChangeTrigger },
            { no: 103, name: "app_user_created", kind: "message", oneof: "kind", T: () => AppUserCreatedTrigger },
            { no: 104, name: "app_user_updated", kind: "message", oneof: "kind", T: () => AppUserUpdatedTrigger },
            { no: 105, name: "usage_based_revocation", kind: "message", oneof: "kind", T: () => UsageBasedRevocationTrigger },
            { no: 106, name: "user_created", kind: "message", oneof: "kind", T: () => UserCreatedTrigger },
            { no: 107, name: "grant_found", kind: "message", oneof: "kind", T: () => GrantFoundTrigger },
            { no: 108, name: "grant_deleted", kind: "message", oneof: "kind", T: () => GrantDeletedTrigger },
            { no: 109, name: "webhook", kind: "message", oneof: "kind", T: () => WebhookAutomationTrigger },
            { no: 110, name: "schedule", kind: "message", oneof: "kind", T: () => ScheduleTrigger },
            { no: 111, name: "form", kind: "message", oneof: "kind", T: () => FormTrigger },
            { no: 112, name: "schedule_app_user", kind: "message", oneof: "kind", T: () => ScheduleTriggerAppUser },
            { no: 113, name: "access_conflict", kind: "message", oneof: "kind", T: () => AccessConflictTrigger }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationTrigger
 */
export const AutomationTrigger = new AutomationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManualAutomationTrigger$Type extends MessageType<ManualAutomationTrigger> {
    constructor() {
        super("c1.api.automations.v1.ManualAutomationTrigger", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ManualAutomationTrigger
 */
export const ManualAutomationTrigger = new ManualAutomationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProfileChangeTrigger$Type extends MessageType<UserProfileChangeTrigger> {
    constructor() {
        super("c1.api.automations.v1.UserProfileChangeTrigger", [
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UserProfileChangeTrigger
 */
export const UserProfileChangeTrigger = new UserProfileChangeTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserCreatedTrigger$Type extends MessageType<UserCreatedTrigger> {
    constructor() {
        super("c1.api.automations.v1.UserCreatedTrigger", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UserCreatedTrigger
 */
export const UserCreatedTrigger = new UserCreatedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCreatedTrigger$Type extends MessageType<AppUserCreatedTrigger> {
    constructor() {
        super("c1.api.automations.v1.AppUserCreatedTrigger", [
            { no: 1, name: "app_id", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id_cel", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AppUserCreatedTrigger
 */
export const AppUserCreatedTrigger = new AppUserCreatedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserUpdatedTrigger$Type extends MessageType<AppUserUpdatedTrigger> {
    constructor() {
        super("c1.api.automations.v1.AppUserUpdatedTrigger", [
            { no: 1, name: "app_id", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id_cel", kind: "scalar", oneof: "appIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AppUserUpdatedTrigger
 */
export const AppUserUpdatedTrigger = new AppUserUpdatedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageBasedRevocationTrigger$Type extends MessageType<UsageBasedRevocationTrigger> {
    constructor() {
        super("c1.api.automations.v1.UsageBasedRevocationTrigger", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "enabled_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "unused_for_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "include_users_with_no_activity", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "run_immediately", kind: "message", oneof: "coldStartSchedule", T: () => RunImmediately },
            { no: 101, name: "run_delayed", kind: "message", oneof: "coldStartSchedule", T: () => RunDelayed },
            { no: 7, name: "targeted_app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16" } } } },
            { no: 8, name: "targeted_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16" } } } },
            { no: 9, name: "excluded_group_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16" } } } },
            { no: 10, name: "excluded_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.UsageBasedRevocationTrigger
 */
export const UsageBasedRevocationTrigger = new UsageBasedRevocationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunImmediately$Type extends MessageType<RunImmediately> {
    constructor() {
        super("c1.api.automations.v1.RunImmediately", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RunImmediately
 */
export const RunImmediately = new RunImmediately$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunDelayed$Type extends MessageType<RunDelayed> {
    constructor() {
        super("c1.api.automations.v1.RunDelayed", [
            { no: 1, name: "cold_start_delay_days", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { gte: 1 } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.RunDelayed
 */
export const RunDelayed = new RunDelayed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter$Type extends MessageType<GrantTriggerFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter", [
            { no: 1, name: "grant_filter", kind: "message", T: () => GrantTriggerFilter_GrantFilter },
            { no: 2, name: "entitlement_filter", kind: "message", T: () => GrantTriggerFilter_EntitlementFilter },
            { no: 3, name: "account_filter", kind: "message", T: () => GrantTriggerFilter_AccountFilter },
            { no: 4, name: "inclusion_list", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionList },
            { no: 5, name: "inclusion_all", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionAll },
            { no: 6, name: "inclusion_criteria", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionCriteria },
            { no: 7, name: "inclusion_list_cel", kind: "message", oneof: "entitlementInclusion", T: () => EntitlementInclusionListCel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter
 */
export const GrantTriggerFilter = new GrantTriggerFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter_GrantFilter$Type extends MessageType<GrantTriggerFilter_GrantFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter.GrantFilter", [
            { no: 101, name: "grant_source_filter", kind: "enum", T: () => ["c1.api.automations.v1.GrantSourceFilter", GrantSourceFilter, "GRANT_SOURCE_FILTER_"] },
            { no: 102, name: "grant_filter_type", kind: "enum", T: () => ["c1.api.automations.v1.GrantFilterType", GrantFilterType, "GRANT_FILTER_TYPE_"] },
            { no: 103, name: "grant_justification_type", kind: "enum", T: () => ["c1.api.automations.v1.GrantJustificationType", GrantJustificationType, "GRANT_JUSTIFICATION_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter.GrantFilter
 */
export const GrantTriggerFilter_GrantFilter = new GrantTriggerFilter_GrantFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter_EntitlementFilter$Type extends MessageType<GrantTriggerFilter_EntitlementFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter.EntitlementFilter", [
            { no: 201, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16" } } } },
            { no: 202, name: "app_entitlement_refs_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 203, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter.EntitlementFilter
 */
export const GrantTriggerFilter_EntitlementFilter = new GrantTriggerFilter_EntitlementFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTriggerFilter_AccountFilter$Type extends MessageType<GrantTriggerFilter_AccountFilter> {
    constructor() {
        super("c1.api.automations.v1.GrantTriggerFilter.AccountFilter", [
            { no: 301, name: "account_type", kind: "enum", T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantTriggerFilter.AccountFilter
 */
export const GrantTriggerFilter_AccountFilter = new GrantTriggerFilter_AccountFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantFoundTrigger$Type extends MessageType<GrantFoundTrigger> {
    constructor() {
        super("c1.api.automations.v1.GrantFoundTrigger", [
            { no: 1, name: "grant_trigger_filter", kind: "message", T: () => GrantTriggerFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantFoundTrigger
 */
export const GrantFoundTrigger = new GrantFoundTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantDeletedTrigger$Type extends MessageType<GrantDeletedTrigger> {
    constructor() {
        super("c1.api.automations.v1.GrantDeletedTrigger", [
            { no: 1, name: "grant_trigger_filter", kind: "message", T: () => GrantTriggerFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GrantDeletedTrigger
 */
export const GrantDeletedTrigger = new GrantDeletedTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookAutomationTrigger$Type extends MessageType<WebhookAutomationTrigger> {
    constructor() {
        super("c1.api.automations.v1.WebhookAutomationTrigger", [
            { no: 1, name: "jwt", kind: "message", oneof: "authConfig", T: () => WebhookListenerAuthJWT },
            { no: 2, name: "hmac", kind: "message", oneof: "authConfig", T: () => WebhookListenerAuthHMAC },
            { no: 3, name: "listener_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WebhookAutomationTrigger
 */
export const WebhookAutomationTrigger = new WebhookAutomationTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormTrigger$Type extends MessageType<FormTrigger> {
    constructor() {
        super("c1.api.automations.v1.FormTrigger", [
            { no: 1, name: "form", kind: "message", T: () => Form }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.FormTrigger
 */
export const FormTrigger = new FormTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorRefs$Type extends MessageType<ConflictMonitorRefs> {
    constructor() {
        super("c1.api.automations.v1.ConflictMonitorRefs", [
            { no: 1, name: "conflict_monitor_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } }, "pgdb.v1.options": { messageBehavior: "MESSAGE_BEHAVIOR_JSONB" } } }
        ], { "pgdb.v1.msg": { nestedOnly: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ConflictMonitorRefs
 */
export const ConflictMonitorRefs = new ConflictMonitorRefs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessConflictTrigger$Type extends MessageType<AccessConflictTrigger> {
    constructor() {
        super("c1.api.automations.v1.AccessConflictTrigger", [
            { no: 100, name: "conflict_monitor_refs", kind: "message", oneof: "conflictMonitorSelector", T: () => ConflictMonitorRefs },
            { no: 101, name: "all_conflict_monitors", kind: "scalar", oneof: "conflictMonitorSelector", T: 8 /*ScalarType.BOOL*/ }
        ], { "pgdb.v1.msg": { nestedOnly: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AccessConflictTrigger
 */
export const AccessConflictTrigger = new AccessConflictTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookListenerAuthJWT$Type extends MessageType<WebhookListenerAuthJWT> {
    constructor() {
        super("c1.api.automations.v1.WebhookListenerAuthJWT", [
            { no: 1, name: "jwks_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "2048", pattern: "^https://.*", uri: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WebhookListenerAuthJWT
 */
export const WebhookListenerAuthJWT = new WebhookListenerAuthJWT$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookListenerAuthHMAC$Type extends MessageType<WebhookListenerAuthHMAC> {
    constructor() {
        super("c1.api.automations.v1.WebhookListenerAuthHMAC", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.WebhookListenerAuthHMAC
 */
export const WebhookListenerAuthHMAC = new WebhookListenerAuthHMAC$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTrigger$Type extends MessageType<ScheduleTrigger> {
    constructor() {
        super("c1.api.automations.v1.ScheduleTrigger", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 3, name: "advanced", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "skip_if_true_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ScheduleTrigger
 */
export const ScheduleTrigger = new ScheduleTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTriggerAppUser$Type extends MessageType<ScheduleTriggerAppUser> {
    constructor() {
        super("c1.api.automations.v1.ScheduleTriggerAppUser", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "cron_spec", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 3, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 5, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ScheduleTriggerAppUser
 */
export const ScheduleTriggerAppUser = new ScheduleTriggerAppUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationTemplateVersion$Type extends MessageType<AutomationTemplateVersion> {
    constructor() {
        super("c1.api.automations.v1.AutomationTemplateVersion", [
            { no: 1, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "automation_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationStep },
            { no: 4, name: "triggers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationTrigger },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationTemplateVersion
 */
export const AutomationTemplateVersion = new AutomationTemplateVersion$Type();
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationSearchService
 */
export const AutomationSearchService = new ServiceType("c1.api.automations.v1.AutomationSearchService", [
    { name: "SearchAutomations", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automations/search", group: "Automations" }] } }, I: SearchAutomationsRequest, O: SearchAutomationsResponse },
    { name: "SearchAutomationTemplateVersions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automation_versions/search", group: "Automations" }] } }, I: SearchAutomationTemplateVersionsRequest, O: SearchAutomationTemplateVersionsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationService
 */
export const AutomationService = new ServiceType("c1.api.automations.v1.AutomationService", [
    { name: "GetAutomation", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automations/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Automation", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Automations" }] } }, I: GetAutomationRequest, O: GetAutomationResponse },
    { name: "CreateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automations", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Automation" }], group: "Automations" }] } }, I: CreateAutomationRequest, O: CreateAutomationResponse },
    { name: "ListAutomations", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automations", group: "Automations" }] } }, I: ListAutomationsRequest, O: ListAutomationsResponse },
    { name: "DeleteAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/automations/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Automation" }], group: "Automations" }] } }, I: DeleteAutomationRequest, O: DeleteAutomationResponse },
    { name: "UpdateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automations/{automation.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Automation" }], group: "Automations" }] } }, I: UpdateAutomationRequest, O: UpdateAutomationResponse },
    { name: "ExecuteAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automations/{id}/execute", group: "Automations" }] } }, I: ExecuteAutomationRequest, O: ExecuteAutomationResponse }
]);
